// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"pc_a bhc_i bhc_j bhc_q bhc_vr bhc_xj bhc_er"};